import { render, staticRenderFns } from "./Mentionable.vue?vue&type=template&id=9a36019a&"
import script from "./Mentionable.vue?vue&type=script&lang=js&"
export * from "./Mentionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a36019a')) {
      api.createRecord('9a36019a', component.options)
    } else {
      api.reload('9a36019a', component.options)
    }
    module.hot.accept("./Mentionable.vue?vue&type=template&id=9a36019a&", function () {
      api.rerender('9a36019a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/Mentionable.vue"
export default component.exports